import React from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheGrandEntrance() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="36669" id="the-soul-of-los-angeles" className="relative h-screen w-full overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay loop muted playsInline className="h-full w-full object-cover" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605600/img/hero_luxury_gala_background.png">
          <source src="/videos/luxury_gala_cinematic.mp4" type="video/mp4" />
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605600/img/hero_luxury_gala_background.png" alt="Luxury gala event with candle light" className="h-full w-full object-cover" />
        </video>
        
        {}
        <div className="absolute inset-0 bg-black/60 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(0,0,0,0.9)_100%)]" />
      </div>

      {}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center">
        <div ref={ref} className={`flex max-w-4xl flex-col items-center space-y-8 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h1 className="font-serif text-6xl font-light leading-tight tracking-tighter text-foreground drop-shadow-2xl italic md:text-8xl lg:text-[120px]">
            Synergy Sound
          </h1>
          
          <p className="max-w-2xl font-mono text-xs uppercase tracking-[0.4em] text-secondary md:text-sm">
            Los Angeles • Soul, R&B, and Timeless Classics
          </p>

          <div className="flex flex-col gap-4 sm:flex-row sm:gap-6">
            <Button asChild size="lg" className="min-w-[200px] border border-secondary bg-transparent font-mono text-xs uppercase tracking-widest text-foreground hover:bg-primary hover:text-primary-foreground hover:shadow-[0_0_25px_var(--primary)/0.3] transition-all duration-500">
              <Link to="#inquiry-form">Inquire for Your Date</Link>
            </Button>
            
            <Button asChild variant="ghost" size="lg" className="min-w-[200px] border border-secondary/30 font-mono text-xs uppercase tracking-widest text-foreground/80 hover:bg-secondary/10 hover:text-secondary hover:border-secondary transition-all duration-500">
              <Link to="#tailored-musical-experiences">Experience the Sound</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 z-20 -translate-x-1/2 animate-bounce">
        <Link to="#services" aria-label="Scroll down">
          <ChevronDown className="h-10 w-10 text-secondary/60 hover:text-secondary transition-colors duration-500" />
        </Link>
      </div>
    </section>;
}